import React from 'react';

import classes from 'classnames';

import styles from './index.module.css';

const Link = ({ children, className, ...rest }) => {
  const linkClasses = classes(styles.link, className, 'custom-typography-link');

  return (
    <a className={linkClasses} {...rest}>
      {children}
    </a>
  );
};

export default Link;
